<div class="text-editor-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Info/Welcome Section</h3>
    <button class="close-btn" (click)="onClose()">
      <img src="assets/images/website-builder/close-icon.svg" alt="Close" width="12" height="12">
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="tabs">
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'content'"
        (click)="onTabChange('content')">
        <img src="assets/images/website-builder/pencil-icon.svg" alt="Content" width="13" height="13">
        Content
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'layout'"
        (click)="onTabChange('layout')">
        <img src="assets/images/website-builder/layout-board-icon.svg" alt="Layout" width="14" height="14">
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    <!-- Title & Description Section -->
    <app-section-accordion 
      title="Title & Description"
      [isExpanded]="isSectionExpanded('heading')"
      (toggle)="toggleSection('heading')">
      
      <!-- Title -->
      <div class="input-group">
        <label class="input-label">Title</label>
        <app-text-editor
          [value]="data.title"
          [style]="data.titleStyle || {}"
          placeholder="Enter title text..."
          (valueChange)="onTitleChange($event)"
          (styleChange)="onTitleStyleChange($event)">
        </app-text-editor>
      </div>

      <!-- Description -->
      <div class="input-group">
        <label class="input-label">Description</label>
        <textarea 
          class="paragraph-input"
          [value]="data.description"
          (input)="onDescriptionChange($any($event.target).value)"
          placeholder="Enter description text...">
        </textarea>
      </div>

    </app-section-accordion>

    <!-- Media Section -->
    <app-section-accordion 
      title="Media"
      [isExpanded]="isSectionExpanded('media')"
      (toggle)="toggleSection('media')">
        <!-- Image Upload Section -->
        <div class="image-upload-section">
          <div class="image-preview-container">
            <div class="image-preview" [style.background-image]="'url(' + data.imageUrl + ')'">
              <div class="image-overlay" *ngIf="!data.imageUrl">
                <div class="upload-placeholder">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <!-- Upload loading overlay -->
              <div class="image-overlay" *ngIf="isUploadingImage" style="background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;">
                <div style="color: white; text-align: center;">
                  <div style="margin-bottom: 8px;">Uploading...</div>
                  <div style="font-size: 12px;">Please wait</div>
                </div>
              </div>
              <!-- Upload error message -->
              <div class="image-overlay" *ngIf="uploadError && !isUploadingImage" style="background: rgba(220, 38, 38, 0.9); display: flex; align-items: center; justify-content: center;">
                <div style="color: white; text-align: center; padding: 8px;">
                  <div style="font-size: 12px;">{{ uploadError }}</div>
                </div>
              </div>
            </div>
            <button class="replace-btn" (click)="onReplaceImage()" [disabled]="isUploadingImage">
              {{ isUploadingImage ? 'Uploading...' : 'Replace' }}
            </button>
          </div>
          
          <div class="file-info">
            <div class="file-info-item">
              <span class="file-info-text">Accepted formats - .png, .jpg, .jpeg, .mp4</span>
              <div class="divider"></div>
              <span class="file-info-text">Max file size - 5MB</span>
            </div>
          </div>
        </div>

        <!-- Image Settings -->
        <div class="image-settings">
          <label class="settings-label">How should the image look?</label>
          <div class="dropdown-container">
            <select class="image-fit-dropdown" [(ngModel)]="data.imageFit" (change)="onImageFitChange($event)">
              <option value="fill">Fill</option>
              <option value="cover">Cover</option>
              <option value="contain">Contain</option>
              <option value="fit">Fit</option>
            </select>
          </div>
        </div>
    </app-section-accordion>

    <!-- Button Section -->
    <app-section-accordion 
      title="Button"
      [isExpanded]="isSectionExpanded('button')"
      (toggle)="toggleSection('button')">
        <!-- Button Text Input -->
        <div class="button-input-group">
          <label class="input-label">Add the button text here*</label>
          <div class="input-container">
            <input 
              type="text" 
              class="button-text-input"
              [(ngModel)]="data.buttonText"
              (input)="onButtonTextChange($any($event.target).value)"
              placeholder="Book Washssss">
          </div>
        </div>

        <!-- Button Navigation Dropdown -->
        <div class="button-input-group">
          <label class="input-label">When clicked, go to page*</label>
          <div class="dropdown-container">
            <select 
              class="navigation-dropdown" 
              [(ngModel)]="data.buttonNavigation" 
              (change)="onButtonNavigationChange($any($event.target).value)">
              <option value="homepage">Homepage</option>
              <option value="express-washes">Express Washes</option>
              <option value="express-detail">Express Detail</option>
              <option value="fleets">Fleets</option>
              <option value="coupons">Coupons</option>
            </select>
          </div>
        </div>
    </app-section-accordion>

    <!-- Background Section -->
    <app-section-accordion 
      title="Background"
      [isExpanded]="isSectionExpanded('background')"
      (toggle)="toggleSection('background')">
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#5E19A1'" (click)="onBackgroundColorChange('#5E19A1')">
              <div class="color-swatch" style="background-color: #5E19A1;"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Orange Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#FF9736'" (click)="onBackgroundColorChange('#FF9736')">
              <div class="color-swatch" style="background-color: #FF9736;"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Green Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#079271'" (click)="onBackgroundColorChange('#079271')">
              <div class="color-swatch" style="background-color: #079271;"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Blue Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#1B5BFF'" (click)="onBackgroundColorChange('#1B5BFF')">
              <div class="color-swatch" style="background-color: #1B5BFF;"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          
          <!-- Divider -->
          <div class="color-divider"></div>
          
          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div class="color-item" 
               *ngFor="let customColor of customColors; trackBy: trackByIndex" 
               [class.selected]="data.backgroundColor === customColor" 
               (click)="openColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
    </app-section-accordion>
  </div>

  <!-- Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="color-picker-content">
        <chrome-picker 
          [(color)]="currentPickerColor" 
          (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>

    </div>
  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="layout-selector">
      <!-- Layout 1: Image Left, Text Right -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '1'"
           (click)="onLayoutChange('1')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 1</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '1'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="getInfoBackgroundColor()">
          <app-info-layout-1-preview
            [data]="getInfoLayout1Data()"
            [headingColor]="headingColor"
            [paragraphColor]="paragraphColor"
            [headingFont]="headingFont"
            [bodyFont]="bodyFont"
            [primaryColor]="primaryColor"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-info-layout-1-preview>
        </div>
      </div>

      <!-- Layout 2: Text Left, Image Right -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '2'"
           (click)="onLayoutChange('2')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 2</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '2'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="getInfoBackgroundColor()">
          <app-info-layout-2-preview
            [data]="getInfoLayout2Data()"
            [headingColor]="headingColor"
            [paragraphColor]="paragraphColor"
            [headingFont]="headingFont"
            [bodyFont]="bodyFont"
            [primaryColor]="primaryColor"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-info-layout-2-preview>
        </div>
      </div>

      <!-- Layout 3: Title Left, Description Right, Image Bottom -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '3'"
           (click)="onLayoutChange('3')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 3</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '3'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="getInfoBackgroundColor()">
          <app-info-layout-3-preview
            [data]="getInfoLayout3Data()"
            [headingColor]="headingColor"
            [paragraphColor]="paragraphColor"
            [headingFont]="headingFont"
            [bodyFont]="bodyFont"
            [primaryColor]="primaryColor"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-info-layout-3-preview>
        </div>
      </div>

      <!-- Layout 4: Description Left, Title Right, Image Bottom (Inverse of Layout 3) -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '4'"
           (click)="onLayoutChange('4')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 4</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '4'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="getInfoBackgroundColor()">
          <app-info-layout-4-preview
            [data]="getInfoLayout4Data()"
            [headingColor]="headingColor"
            [paragraphColor]="paragraphColor"
            [headingFont]="headingFont"
            [bodyFont]="bodyFont"
            [primaryColor]="primaryColor"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-info-layout-4-preview>
        </div>
      </div>

      <!-- Layout 5: Grime Fighters Layout - Title, Description, Image Row, Large Title -->
      <div class="layout-card" 
           [class.selected]="getSelectedLayout() === '5'"
           (click)="onLayoutChange('5')">
        <div class="layout-card-header">
          <span class="layout-label">Layout 5</span>
          <div class="checkmark" *ngIf="getSelectedLayout() === '5'">
            <img src="assets/images/website-builder/checkmark-icon.svg" alt="Selected" width="16" height="16">
          </div>
        </div>
        <div class="layout-preview-wrapper" [style.background-color]="getInfoBackgroundColor()">
          <app-info-layout-5-preview
            [data]="getInfoLayout5Data()"
            [headingColor]="headingColor"
            [paragraphColor]="paragraphColor"
            [headingFont]="headingFont"
            [bodyFont]="bodyFont"
            [primaryColor]="primaryColor"
            [titleStyles]="data.titleStyle || {}"
            (buttonClick)="$event.event.preventDefault()">
          </app-info-layout-5-preview>
        </div>
      </div>
    </div>
  </div>
</div>
